import { useState, useEffect, useRef, Fragment, memo, useMemo, useCallback } from "react";
import style from "./../index.module.scss";
import styleUi from "./EditNotice.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { wait } from "../../comm/comm";
import TabList from "../../comm/global/components/TabList";
import apiManager from './../../ApiManager';
import AppConfig from './../../AppConfig';
const dotSymbol = "•";
const MAX_CHAR = 150;
const EditNotice = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [tableData3, set_tableData3] = useState([
        { label: "交通", notice: dotSymbol },
        { label: "住宿", notice: dotSymbol },
        { label: "裝備", notice: dotSymbol },
        { label: "餐飲", notice: dotSymbol },
    ]);
    const [editing, set_editing] = useState(true);
    const [tagSelectId, set_tagSelectId] = useState(arg.tabSelectId);
    const [tempArr, set_tempArr] = useState([[], [], [], []]);
    useEffect(() => {
        const _tempArr = [];
        AppConfig.announcementTags.forEach(title => {
            const findObj = arg.event_announcement.find(obj => obj.event_announcement_category === title);
            if (findObj) {
                _tempArr.push({ label: title, notice: findObj.event_announcement_message.map(v => `${dotSymbol}${v}`).join("\n") });
            }
            else {
                _tempArr.push({ label: title, notice: dotSymbol });
            }
        })
        set_tableData3(_tempArr);
        setInProp(true);
    }, [])
    const handletTableDataChangeForNotice = useCallback((setFn, key, index, event) => {
        setFn(prev => {
            const newTableData = [...prev];
            if (event.target.value === "")
                event.target.value = dotSymbol;
            newTableData[index][key] = event.target.value;

            return newTableData;
        });
    }, [tableData3]);
    const handleKeyDown = useCallback(async (setFn, key, index, event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default behavior if needed
            if (CalContentLen() < MAX_CHAR-1) {
                setFn(prev => {
                    const newTableData = [...prev];
                    newTableData[index][key] += `\n${dotSymbol}`;
                    return newTableData;
                });
            }
        }

        if (event.key === 'Backspace') {
            if (tableData3[index][key] === dotSymbol) {
                return event.preventDefault();
            }
            await wait(200);
            setFn(prev => {
                const newTableData = [...prev];
                let lines = newTableData[index][key].split('\n');
                lines = lines.filter(line => line !== '');
                newTableData[index][key] = lines.join('\n');
                return newTableData;
            });
        }
    }, [tableData3]);
    const CalContentLen = () => {
        let num = tableData3[tagSelectId].notice.length;
        if (editing === false) {
            let totalLength = 0;
            tempArr[tagSelectId].forEach(item => {
                totalLength += item.str.length;
            });
            totalLength += tempArr[tagSelectId].length;
            if (tempArr[tagSelectId].length >= 1)
                totalLength -= 1;

            num = totalLength;
        }
        return num;
    }
    const NoticeTag = ({ isSelect, data, index, onClick, selectId }) => {
        return (
            <div className={isSelect ? `${styleUi.item} ${styleUi.selected}` : styleUi.item}>
                <div className={styleUi.label} onClick={e => { onClick(index) }} >
                    <span>{data.label}</span>
                </div>
                <div className={index === selectId - 1 ? `${styleUi.hidden}` : styleUi.separator}></div>
            </div>
        );
    }
    const GenNoticeItem = ({ }) => {
        return (
            <>
                {
                    tempArr[tagSelectId].map((v, k) => {
                        if (v.str !== "")
                            return <div key={k} className={styleUi.item}>
                                <input type="checkbox" id={`notice_${k}`} checked={v.checked} name={`notice_${k}`} onChange={e => {
                                    set_tempArr(prev => {
                                        const _temp = [...prev];
                                        _temp[tagSelectId][k].checked = !_temp[tagSelectId][k].checked;
                                        return _temp;
                                    })
                                }} />
                                <label htmlFor={`notice_${k}`}>{v.str}</label>
                            </div>
                    })
                }
            </>
        );
    }
    function editEnd() {
        let newTableData3 = tableData3.map((item, index) => {
            if (tempArr[index]) {
                const noticeStr = tempArr[index].map(obj => dotSymbol + obj.str).join("\n");
                return { ...item, notice: noticeStr };
            }
            return item;
        });
        set_tableData3(newTableData3);
        set_editing(true);
    }
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "EditNotice"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.header}>
                                    <img src="./assets/ui/back.png" onClick={e => {
                                        setInProp(false)
                                    }} />
                                </div>
                                <div className={styleUi.ctrl}>
                                    <span>重點公告</span>
                                    {editing === true &&
                                        <span onClick={e => {
                                            const data = tableData3.map(v => {
                                                return { event_announcement_category: v.label, event_announcement_message: v.notice.replaceAll("•", "").split("\n") }
                                            })
                                            apiManager.fetchPost(`event/${arg.eventsId}/announcement`, data.filter(v => v.event_announcement_message[0] !== ""), 0).then(res => {
                                                if (res.length)
                                                    arg.set_event_announcement(res[0].event_announcement);
                                                else
                                                    arg.set_event_announcement([]);
                                                setInProp(false);
                                            }).catch(err => {
                                            })
                                        }}>儲存</span>
                                    }
                                </div>
                                <div className={styleUi.noticePanel}>
                                    <div className={styleUi.tagList} style={{ zIndex: "100" }}>
                                        <TabList selectId={tagSelectId} set_selectId={set_tagSelectId} list={tableData3} ItemCls={NoticeTag} clear={false} />
                                    </div>
                                    <div className={styleUi.noticeData}>
                                        {editing ?
                                            <>
                                                <textarea id="story" name="story" rows="5" maxLength={MAX_CHAR} value={tableData3[tagSelectId].notice} onChange={event => {
                                                    handletTableDataChangeForNotice(set_tableData3, "notice", tagSelectId, event)
                                                }} onKeyDown={event => { handleKeyDown(set_tableData3, "notice", tagSelectId, event) }}>
                                                </textarea>
                                                <div className={styleUi.selBtn} onClick={e => {
                                                    let temp = [];
                                                    tableData3.forEach((v, k) => {
                                                        let _temp = [];
                                                        if (v.notice !== "") {
                                                            const arr = v.notice.split("\n");
                                                            arr.forEach(str => {
                                                                if (str !== "")
                                                                    _temp.push({ str: str.substring(1), checked: false });
                                                            })
                                                        }
                                                        temp.push(_temp);
                                                    })
                                                    set_tempArr(temp);
                                                    set_editing(false);
                                                }}><span>選擇</span><img src='./assets/ui/Delete.png' /></div>
                                            </>
                                            :
                                            <GenNoticeItem />
                                        }

                                    </div>
                                    <span>{`${CalContentLen()}/${MAX_CHAR}`}</span>


                                </div>
                                {editing === false &&
                                    <div className={styleUi.editTool}>
                                        <button disabled={!tempArr[tagSelectId].find(v => v.checked)} onClick={e => {
                                            addModalType({
                                                cls: "AlertCustom", arg: {
                                                    title: "要刪除此公告嗎?",
                                                    desc: "刪除後將無法復原。",
                                                    options: [
                                                        {
                                                            label: "刪除", cb: () => {
                                                                set_tempArr(prev => {
                                                                    const _temp = [...prev];
                                                                    const newArr = _temp[tagSelectId].filter(v => !v.checked);
                                                                    _temp[tagSelectId] = newArr;
                                                                    return _temp;
                                                                });
                                                            }
                                                        },
                                                        {
                                                            label: "取消", cb: () => {
                                                            }
                                                        },
                                                    ],
                                                }
                                            })

                                        }}>刪除</button>
                                        <button disabled={!tempArr[tagSelectId].find(v => v.checked)} onClick={e => {
                                            addModalType({
                                                cls: "SelectTag", arg: {
                                                    tags: tableData3, tagSelectId: tagSelectId, cb: selInd => {
                                                        set_tempArr(prev => {
                                                            const _temp = [...prev];
                                                            const newArr = _temp[tagSelectId].filter(v => !v.checked);
                                                            const addArr = _temp[tagSelectId].filter(v => v.checked);
                                                            addArr.map(v => {
                                                                v.checked = false;
                                                            })
                                                            _temp[tagSelectId] = newArr;
                                                            _temp[selInd] = _temp[selInd].concat(addArr);
                                                            return _temp;
                                                        });
                                                    }
                                                }
                                            });
                                        }}>移動至</button>
                                        <button onClick={e => {
                                            editEnd();
                                        }}>完成</button>
                                    </div>}
                                {/* <div style={{ position: "absolute", width: "100%", height: "100%", background: "#00000055",left:"0px",top:"0px" }}>
                                        </div> */}
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(EditNotice);